var map = {
	"./aokTheme.json": "./src/common/providers/ThemeProvider/aokTheme.json",
	"./darkTheme.json": "./src/common/providers/ThemeProvider/darkTheme.json",
	"./defaultTheme.json": "./src/common/providers/ThemeProvider/defaultTheme.json",
	"./fraunhoferTheme.json": "./src/common/providers/ThemeProvider/fraunhoferTheme.json",
	"./orbisTheme.json": "./src/common/providers/ThemeProvider/orbisTheme.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/common/providers/ThemeProvider sync recursive ^\\.\\/.*\\.json$";